export const routes = {
  home: '/',
  cleaning: '/cleaning',
  capture: '/capture',
  captureDetail: '/capture/:id',
  credits: '/credits',
  notFound: '*',
} as const;
